import Error from '../model/Error';
import InvoiceTemplate from '../dto/InvoiceTemplate';
import axios from 'axios';

export default class ClubInvoiceTemplateRepository {

    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/invoice-templates`, {  })
                .then(response => resolve(response.data.data.map(data => InvoiceTemplate.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubLegacy(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/invoice-templates`, {  })
                .then(response => resolve(response.data.data.map(data => InvoiceTemplate.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubId, invoiceTemplates) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/invoice-templates`, { invoiceTemplates: invoiceTemplates.map(i => i.serialize()) })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
